import { render, staticRenderFns } from "./BigCrunchAutobuyerBox.vue?vue&type=template&id=5de610fa&scoped=true&"
import script from "./BigCrunchAutobuyerBox.vue?vue&type=script&lang=js&"
export * from "./BigCrunchAutobuyerBox.vue?vue&type=script&lang=js&"
import style0 from "./BigCrunchAutobuyerBox.vue?vue&type=style&index=0&id=5de610fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de610fa",
  null
  
)

export default component.exports